import React, { useState } from "react";
import projects from "./projects.json";
import "./projects.css";
export default function Projects() {
  const liveProjects = ["Fundy", "Movie App","Positivus","Fast Feast","Admin Dashboard"];
  const frontendProjects = projects.filter((project) =>
    project.category.includes("Frontend")
  );
  const backendProjects = projects.filter((project) =>
    project.category.includes("Backend")
  );
  const fullStackProjects = projects.filter((project) =>
    project.category.includes("Full-Stack")
  );

  const [currentProjects, setCurrentProjects] = useState(projects);
  const [selectedCategory, setSelectedCategory] = useState("All");

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    switch (category) {
      case "Backend":
        setCurrentProjects(backendProjects);
        break;
      case "Frontend":
        setCurrentProjects(frontendProjects);
        break;
      case "Full-Stack":
        setCurrentProjects(fullStackProjects);
        break;
      default:
        setCurrentProjects(projects);
        break;
    }
  };

  const handleMouseEnter = (e) => {
    e.target.className += " enter";
  };
  const handleMouseLeave = (e) => {
    e.target.className = "project-img-container";
  };

  return (
    <>
      <div className="projectsContainer">
        <div className="projectTitle">
          <h1>Projects</h1>
          <div>
            <hr />
          </div>
        </div>
        <div className="projects-category">
          <span
            onClick={() => handleCategoryClick("All")}
            className={selectedCategory === "All" ? "categoryActive" : ""}
          >
            All
          </span>
          <span
            onClick={() => handleCategoryClick("Backend")}
            className={selectedCategory === "Backend" ? "categoryActive" : ""}
          >
            Backend
          </span>
          <span
            onClick={() => handleCategoryClick("Frontend")}
            className={selectedCategory === "Frontend" ? "categoryActive" : ""}
          >
            Frontend
          </span>
          <span
            onClick={() => handleCategoryClick("Full-Stack")}
            className={selectedCategory === "Full-Stack" ? "categoryActive" : ""}
          >
            Full-Stack
          </span>
        </div>
        <div className="projects" key={selectedCategory}>
          {currentProjects.map((project) => {
            return (
              <div key={project.id} className="projectContainer">
                <div className="project-img-container">
                  <a href={project.link} target="_blank" rel="noreferrer">
                    <img
                      src={require(`${project.img}`)}
                      
                      alt={project.name}
                      onMouseEnter={(e) => handleMouseEnter(e)}
                      onMouseLeave={(e) => handleMouseLeave(e)}
                    />
                  </a>
                </div>
                <div className="project-content">
                  <h4>{project.Description}</h4>
                  {liveProjects.includes(project.name) ? (
                    <>
                      <div className="project-content-normal">
                        <div className="project-content-live">
                          <h2>{project.name}</h2>
                          <a
                            href={project.live}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Live
                          </a>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="project-content-normal">
                      <h2>{project.name}</h2>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
   
    </>
  );
}
